export default "__VITE_ASSET__B_Hsz7Aa__"